import type { CartLineItem } from '@repo/ui/src/types/cart';

interface HydrogenCartLine {
  id?: string | null;
  quantity?: number | null;
  cost?: {
    totalAmount?: { amount?: string | null } | null;
  } | null;
  merchandise?: {
    product?: { title?: string | null; handle?: string | null } | null;
    image?: { url?: string | null; altText?: string | null } | null;
    compareAtPrice?: { amount?: string | null } | null;
  } | null;
}

export function mapHydrogenCartLineToCartLineItem(line: HydrogenCartLine): CartLineItem {
  const qty = line.quantity ?? 1;
  const lineTotal = parseFloat(line.cost?.totalAmount?.amount ?? '0');
  const compareAtPerUnit = line.merchandise?.compareAtPrice?.amount
    ? parseFloat(line.merchandise.compareAtPrice.amount)
    : undefined;
  const compareAtTotal = compareAtPerUnit != null ? compareAtPerUnit * qty : undefined;

  return {
    id: line.id ?? '',
    title: line.merchandise?.product?.title ?? '',
    imageUrl: line.merchandise?.image?.url ?? '',
    imageAlt: line.merchandise?.image?.altText ?? '',
    price: lineTotal,
    originalPrice: compareAtTotal,
    hasDiscount: compareAtTotal != null && compareAtTotal > lineTotal,
    quantity: qty,
    meta: {
      handle: line.merchandise?.product?.handle ?? undefined,
    },
  };
}
